import { DriverV2 } from "@hagerty/customer-insurance-gateway-client";

export const getMockDrivers = (): DriverV2[] => [
  {
    memberId: 100001,
    name: {
      prefix: "Mr.",
      first: "ARLENE",
      last: "Candler",
    },
    dateOfBirth: "1962-06-29T00:00:00",
    driverType: "PRIMARY",
    isVehicleOperator: true,
  },
  {
    memberId: 100002,
    name: {
      prefix: "Mrs.",
      first: "EDNA",
      last: "Candler",
    },
    dateOfBirth: "1966-12-13T00:00:00",
    driverType: "SECONDARY",
    isVehicleOperator: false,
  },
];
